/**
 * Returns an ISO date string set to a future date
 * @param {number} yearsToAdd - Number of years to add to current date
 * @returns {string} ISO date string (YYYY-MM-DD)
 */
export const getFutureDate = (yearsToAdd = 2) => {
  return new Date(new Date().setFullYear(new Date().getFullYear() + yearsToAdd))
    .toISOString()
    .split('T')[0]
}

/**
 * Formats a date into a readable string
 * @param {Date|string|null|undefined} date - Date object or ISO date string
 * @param {Object} options - Formatting options for toLocaleDateString
 * @param {string} locale - Locale for formatting (defaults to 'en-GB')
 * @returns {string} Formatted date string
 */
export const formatDate = (
  date,
  options = { day: 'numeric', month: 'long', year: 'numeric' },
  locale = 'en-GB'
) => {
  if (!date) return ''
  const dateObj = date instanceof Date ? date : new Date(date)
  if (isNaN(dateObj.getTime())) return ''
  return dateObj.toLocaleDateString(locale, { timeZone: 'Europe/London', ...options })
}
